export default __webpack_public_path__ + "static/media/blockProfile.238b71fb.svg";